"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisabilityInsurancePremiums = DisabilityInsurancePremiums;
exports.FitnessGym = FitnessGym;
exports.HealthcareInsurancePremium = HealthcareInsurancePremium;
exports.HomeHealthCare = HomeHealthCare;
exports.LifeInsurancePremiums = LifeInsurancePremiums;
exports.LongTermCarePremiums = LongTermCarePremiums;
exports.MedicalServices = MedicalServices;
exports.MedicalSupplies = MedicalSupplies;
exports.OtherExpenses = OtherExpenses;
exports.OutOfPocketServices = OutOfPocketServices;
exports.Prescriptions = Prescriptions;
exports.VitaminsMedicines = VitaminsMedicines;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function HealthcareInsurancePremium(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'healthcare_insurancePremium';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Health Insurance Premium (Including Medicare)',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function MedicalServices(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'healthcare_medicalServices';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Medical Services',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HomeHealthCare(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'healthcare_homeHealthCare';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Home Health Care',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Prescriptions(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'healthcare_prescriptions';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Prescriptions',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function MedicalSupplies(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'healthcare_medicalSupplies';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Medical Supplies',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function VitaminsMedicines(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'healthcare_vitaminsMedicines';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Vitamins and OTC Medicines',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function OutOfPocketServices(_ref7) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'healthcare_outOfPocketServices';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Out-of-Pocket Services (e.g. Physical Therapy)',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FitnessGym(_ref8) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref8;
  var fieldName = 'healthcare_fitnessGym';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Fitness and Gym Memberships',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function LifeInsurancePremiums(_ref9) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref9;
  var fieldName = 'healthcare_lifeInsurancePremiums';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Life Insurance Premiums',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function LongTermCarePremiums(_ref10) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'healthcare_longTermCarePremiums';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Long-Term Care Premiums',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function DisabilityInsurancePremiums(_ref11) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'healthcare_disabilityInsurancePremiums';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Disability Insurance Premiums',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function OtherExpenses(_ref12) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref12;
  var fieldName = 'healthcare_otherExpenses';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Other',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}